import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Sidebar } from '../components/common/sidebar/Sidebar';
import './viewApp.scss';
import menus from '../configs/menu';
import { useUserContext } from '../context/UserContext';
import { useLayoutContext } from '../context/LayoutContext';
import { LoadingContainer } from '../components/common/LoadingContainer';
import { PATHS } from '../configs/path';
import TopBar from '../container/TopBar';
import { Hidden } from '@material-ui/core';
import { BecomeMemberComponent } from '../components/common/BecomeMemberComponent';
import { MEMBER_SUBSCRIPTION_STATUS } from '../constants/appConst';

export const ViewApp = () => {
  const { user, loadingUserDetails } = useUserContext();
  const { showNavBar } = useLayoutContext();
  const [isNavBarOpen, setNavBarOpen] = useState(showNavBar);

  const userNotFound = !loadingUserDetails && (!user?.id || user?.member_status === MEMBER_SUBSCRIPTION_STATUS.CANCELLED);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isSM = windowWidth <= 600;
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
      setNavBarOpen(showNavBar);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
        setNavBarOpen(showNavBar);
      });
    };
  }, []);

  return (
    <div className='main-inner-container'>
      {loadingUserDetails ? (
        <div
          className='loadingContainer'
          style={{
            maxWidth: '200px',
            margin: 'auto',
            marginTop: '40px',
          }}
        >
          <LoadingContainer />
        </div>
      ) : user?.error || user?.error === 'Network Error' ? (
        <div
          className='loadingContainer'
          style={{
            maxWidth: 270,
            paddingTop: 15,
            paddingBottom: 15,
            margin: 'auto',
            marginTop: '40px',
            fontFamily: `Brown`,
            backgroundColor: 'white',
            textAlign: 'center',
          }}
        >
          <h2 style={{ marginBottom: 0 }}>
            There is no internet connection or server error!
          </h2>
        </div>
      ) : userNotFound ? (
        <BecomeMemberComponent />
      ) : (
        <div className={isSM ? 'main-inner-body-mobile' : 'main-inner-body'}>
          {!isSM && showNavBar ? <Sidebar /> : null}
          {isSM && isNavBarOpen ? (
            <Sidebar isMobileView onClick={() => setNavBarOpen(false)} />
          ) : null}
          {isSM && showNavBar ? (
            <TopBar onMobileNavOpen={() => setNavBarOpen(!isNavBarOpen)} />
          ) : null}
          <div className='main-inner-body-port'>
            <Container
              className={!isSM && 'mt-4'}
              style={{
                marginTop: isSM ? '5.5rem' : undefined,
              }}
            >
              <Switch>
                {menus
                  .filter((menu) => !menu.target)
                  .map((menu, index) => (
                    <Route
                      key={`route_${index}`}
                      path={`${menu.to}/:id?`}
                      render={(props) => <menu.component {...props} />}
                    />
                  ))}

                <Redirect to={user.member_status !== MEMBER_SUBSCRIPTION_STATUS.CANCELLED ? PATHS.rentals : PATHS.profile} />
              </Switch>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
};
